import "./css/location.modules.css";

import React, { useEffect, useRef } from "react";

import "../components/Tabs2.css";

import SubHeader from "../components/subHeader";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import Cookies from "universal-cookie";
import location_icon from "./img/icon/location_icon.png";
import phone_icon from "./img/icon/phone_icon.png";
import 물류 from "./img/물류.png";

import map from "./img/overview/map.png";

const { kakao } = window;
const cookies = new Cookies();

const Location = () => {
  /*카카오 지도 설정*/
  useEffect(() => {
    var container;
    var options;
    var markerPosition;

    markerPosition = new kakao.maps.LatLng(
      37.5896133029014,
      126.854406977825
    );
    container = document.getElementById("maps");
    options = {
      center: new kakao.maps.LatLng(37.5896133029014, 126.854406977825),
      level: 3,
    };

    var map = new kakao.maps.Map(container, options);
    var marker = new kakao.maps.Marker({
      position: markerPosition,
      text: "GM메디칼",
    });

    var zoomControl = new kakao.maps.ZoomControl();
    map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

    var content =
      '<div className ="label" style="margin-top:34px;font-weight:bold;color:#000B52;><span className="left"></span><span className="center">GM메디칼</span><span className="right"></span></div>';
    var customOverlay = new kakao.maps.CustomOverlay({
      position: markerPosition,
      content: content,
    });
    marker.setMap(map);
    customOverlay.setMap(map);





  }, []);
  /* 언어 처리 */
  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);
  return (
    <div className="wrapper">
      <SubHeader />

      <div className="div_wrapper">
        <div className="section_title">
          <h1 className="headerText">{i18next.t("location.title")}</h1>
        </div>


        <div className="location"  style={{display:"flex"}}>

          <div className="map_wrap">
          <div id="maps"></div>

<div className="wrap_controllers hide">
  <a
    className="tit_controllers"
    href="https://map.kakao.com"
    target="_blank"
    rel="noreferrer"
  >
    <img
      src="//t1.daumcdn.net/localimg/localimages/07/2018/pc/common/logo_kakaomap.png"
      width="72"
      height="16"
      alt="카카오맵"
      style={{ display: "block", width: "72px", height: "16px" }}
    />
  </a>
  <div className="wrap_btn_roadview">
    <a
      className="txt"
      target="_blank"
      rel="noreferrer"
      href="https://map.kakao.com/?map_type=TYPE_MAP&target=car&rt=,,467868,1136188&rt1=&rt2=%EC%97%A0%EC%97%90%EC%9D%B4%EC%B9%98%ED%99%80%EB%94%A9%EC%8A%A4&rtIds=,111368703"
    >
      {i18next.t("location.direction")}
    </a>
  </div>
</div>
          </div>
        
          <div className="maps_desc">
            <div className="map_header" style={{display:"flex", justifyContent:"space-between"}}>
            <h3>본사</h3>
            <div className="map_btns">
            <button><a href="https://place.map.kakao.com/111368703" style={{color:"white"}} target="_blank" rel="noopener noreferrer">카카오맵 보기</a></button>
            <button><a href="https://naver.me/FSwjtzgO" style={{color:"white"}} target="_blank" rel="noopener noreferrer">네이버 지도 보기</a></button>
            </div>
            
            </div>
            
            <div className="map_txt">
              <div className="row">
                <p>주소</p>
                <p>{i18next.t("location.address")}</p>
              </div>
              <div className="row">
              <p>TEL</p>
                      <a href="tel:02-2055-2255">
                        
                        02-2055-2255
                      </a>

              </div>
              <div className="row">
              <p>TEL</p>
                      <a href="tel:02-2055-1177">
                        
                        02-2055-1177
                      </a>

              </div>
                <div className="row">
                 
                <p>E-mail</p>
                      <a href="mailto: gmmedical1@naver.com">
                       
                        gmmedical1@naver.com
                      </a>
                </div>
                {/* 
                <div className="row">
                  <p>오시는 길</p>
                  <div className="subway" style={{width:"auto"}}>
            <div className="substance">
              <span className="icon">2</span>
              <span>{i18next.t("location.subway2")}</span>
            </div>
          </div>
                </div>
              */}
              </div>
            </div>


           
            
          </div>
         
{/*
          <div className="location"  style={{display:"flex"}}>

<div className="map_wrap">
<img src={물류} alt="물류" style={{width:"100%", height:"400px"}}></img>

</div>

<div className="maps_desc">
  <div className="map_header" style={{display:"flex", justifyContent:"space-between"}}>
  <h3>물류</h3>
  <div>
  <button><a href="https://place.map.kakao.com/111368703" style={{color:"white"}} target="_blank" rel="noopener noreferrer">카카오맵 보기</a></button>
  <button><a href="https://naver.me/FSwjtzgO" style={{color:"white"}} target="_blank" rel="noopener noreferrer">네이버 지도 보기</a></button>
  </div>
  
  </div>
  
  <div className="map_txt">
    <div className="row">
      <p>주소</p>
      <p>경기 고양시 덕양구 해포길 55-23 뷰티플래닛 빌딩 1층</p>
    </div>
 
    <div className="row">
              <p>TEL</p>
                      <a href="tel:02-2055-2255">
                        
                        02-2055-2255
                      </a>

              </div>
                <div className="row">
                 
                <p>E-mail</p>
                      <a href="mailto: gmmedical1@naver.com">
                       
                        gmmedical1@naver.com
                      </a>
                </div>
    </div>
  </div>

  
</div>
*/}

<div className="customer_mgmt" style={{
display: "flex",
    flexDirection: "column",
    paddingBottom:"100px",
    alignItems: "center"
}}>
          <h1 className="business_header">
            {i18next.t("overview.customers.title")}
          </h1>
          <img src={map} alt="회사 개요" style={{width:"500px"}}></img>

          <div className="">
            <p>{i18next.t("overview.customers.summary")}</p>
          </div>
        </div>



        </div>

      {/*<Tabs defaultActiveKey="first">
        <Tab eventKey="first" title="본사사옥">
        <div id="map"></div>
        </Tab>
        <Tab eventKey="second" title="생산공장">
          Hii, I am 2nd tab content
        </Tab>
      
    </Tabs>*/}
    </div>
  );
};

export default Location;
